import { CapoPlugin } from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];